/* ADD Knowledge categories */
export const ADD_SUPPORT_MATERIAL = "ADD_SUPPORT_MATERIAL"
export const ADD_SUPPORT_MATERIAL_SUCCESS = "ADD_SUPPORT_MATERIAL_SUCCESS"
export const ADD_SUPPORT_MATERIAL_CLEAN = "ADD_SUPPORT_MATERIAL_CLEAN"
export const ADD_SUPPORT_MATERIAL_ERROR = "ADD_SUPPORT_MATERIAL_ERROR"
